import { Routes } from '@angular/router';
import { ScopeGuard } from '../auth/services/scope.guard';
import { SCOPES } from 'src/app/app.constants';
import { ItemEditComponent } from './components/item-edit/item-edit.component';
import { UNSAVED_CHANGES_GUARD } from 'src/app/_avmin/guards/unsaved-changes.guard';

export const ITEM_ROUTES: Routes = [
  {
    path: ':id',
    loadComponent: () => import('./components/item-view/item-view.component').then(m => m.ItemViewComponent),
    canActivate: [ScopeGuard],
    data: { scopes: [SCOPES.items.manage] },
    canDeactivate: [async (component: ItemEditComponent) => await UNSAVED_CHANGES_GUARD(component.hasUnsavedChanges)],
    children: [
      { path: 'components', loadComponent: () => import('./components/item-components/item-components.component').then(m => m.ItemComponentsComponent) },
      { path: '**', loadComponent: () => import('./components/item-edit/item-edit.component').then(m => m.ItemEditComponent) }
    ]
  },
  { path: '', loadComponent: () => import('./components/item-list/item-list.component').then(m => m.ItemListComponent) }
];
